export default function ownerDocument(_0x18e863){return _0x18e863&&_0x18e863['ownerDocument']||document;}